import { BIO_METRIC_STATUS, CONFIRM_CHECKBOX, COUNTRY, PROOF_IDENTITY_SELECTED_OPTION, } from '../FormFields/fieldNames.js';
export const proofOfIdentitydefaultValues = {
    [PROOF_IDENTITY_SELECTED_OPTION]: '',
    [COUNTRY]: '',
    [BIO_METRIC_STATUS]: '',
    [CONFIRM_CHECKBOX]: false,
};
//# sourceMappingURL=types.js.map